module.exports = __webpack_public_path__ + "img/videopic.08db0784.jpg";